<template>
  <div>
    <SnackBar />
    <router-view v-if="showContent" />
    <div class="desktop text-center d-flex align-center ma-16" v-else>
      This content is visible only on mobile screens.
    </div>
  </div>
</template>

<script>
import SnackBar from "@/components/SnackBar.vue";
export default {
  name: "App",

  components: {
    SnackBar
  },

  data: () => ({
    isMobile: false
  }),
  computed: {
    showContent() {
      // Allow normal mobile flow OR explicitly allow the two media redirect routes on desktop
      const path = this.$route?.path;
      const allowedMediaPaths = [
        "/media/84e3e4a7-bae1-41a2-a11f-5c6b5331e775",
        "/media/c0043cd0-de43-482d-a637-5e9bc63d5c24",
        "/media/165f2e42-b08f-4f8f-95a0-21fbd3270081",
        "/media/a6c8fce4-7912-41d1-b4f5-99c2f7392b10"
      ];
      return this.isMobile || (path && allowedMediaPaths.includes(path));
    }
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.outerWidth <= 600;
    }
  }
};
</script>
<style scoped>
.desktop {
  font-size: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Roboto";
  font-weight: 500;
  color: black;
  min-height: 100vh;
}
.v-application--wrap {
  min-height: unset;
}
</style>
